const $ = jQuery.noConflict();

const mainHeader = document.querySelector('.main-header');

const clickOffMenu = (e) => {
    if (e.target.classList.contains('tec-body')) {
        closeFilters(document.querySelector('.tec-mobile-filters'));
    }
};

const clickSubmitButton = (e) => {
    if (e.target.classList.contains('tribe-events-c-search__button') || e.target.classList.contains('tec-reset__reset-btn')) {
        closeFilters(document.querySelector('.tec-mobile-filters'));
    }
};

const closeFilters = (target) => {
    let rect = target.getBoundingClientRect();
    target.classList.remove('active');
    target.parentElement.classList.remove('active');
    document.body.classList.remove('lock-scroll');
    document.body.classList.remove('tec-filters-open');

    document.removeEventListener('click', clickOffMenu);
    document.removeEventListener('click', clickSubmitButton);
    
    $('html, body').animate({
        scrollTop: rect.top + window.pageYOffset + 1 - mainHeader.offsetHeight,
    }, 600);
};

const openFilters = (target) => {
    let rect = target.getBoundingClientRect();
    target.classList.add('active');
    target.parentElement.classList.add('active');
    document.body.classList.add('lock-scroll');
    document.body.classList.add('tec-filters-open');

    document.addEventListener('click', clickOffMenu);
    document.addEventListener('click', clickSubmitButton);

    $('html, body').animate({
        scrollTop: rect.top + window.pageYOffset - mainHeader.offsetHeight + 1,
    }, 500);
};

const toggleFilters = (e) => {
    if (e.target.classList.contains('tec-mobile-filters')) {
        if (e.target.classList.contains('active')) {
            closeFilters(e.target);
        } else {
            openFilters(e.target);
        }
    }
};

const TECMobileFilters = () => {
    if (document.body.classList.contains('tribe-events-page-template')) {
        document.addEventListener('click', toggleFilters);
    }
};

export default TECMobileFilters;
